export const questionsData = [
  {
    id: 5345341,
    title: "Ta'lim sifati qoniqarlimi?!",
    item: "Bizning kursimizga asosan boshqa kurslarda qatnashib, o`z bilim salohiyatlarini to`ldira olmagan o`quvchilar tashrif buyurishadi va oʻrganishadi. Zamonaviy uslubda, eng so`ngi metodikalar va oliy darajali, puxta tayyorgarlik asosida darslar olib boriladi.",
  },
  {
    id: 5345342,
    title: "Yaxshi o`rgana olamanmi?!",
    item: "Kusr uchun to’lo’vlarni Terminal yoki Naqd pul ko’rinishida to’lashingiz mumkin bo’ladi. ",
  },
  {
    id: 5345343,
    title: "Kelajakda menga foydasi bormi, manfaatlimi?!",
    item: "Kusr uchun to’lo’vlarni Terminal yoki Naqd pul ko’rinishida to’lashingiz mumkin bo’ladi. ",
  },
  {
    id: 5345344,
    title: "Markaz sharoiti yaxshimi?!",
    item: "Kusr uchun to’lo’vlarni Terminal yoki Naqd pul ko’rinishida to’lashingiz mumkin bo’ladi. ",
  },
  {
    id: 5345345,
    title: "Bu o'qish qonuniymi, noqonuniy fanlar oʻtilmaydimi?",
    item: "Kusr uchun to’lo’vlarni Terminal yoki Naqd pul ko’rinishida to’lashingiz mumkin bo’ladi. ",
  },
  {
    id: 5345346,
    title: "Bu o'qish qonuniymi, noqonuniy fanlar oʻtilmaydimi?",
    item: "Kusr uchun to’lo’vlarni Terminal yoki Naqd pul ko’rinishida to’lashingiz mumkin bo’ladi. ",
  },
];
